import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import { useCmsContent } from '@sentecacommerce-theme/lib'
import { Typography, Copy } from '../../../Common'
import { BlogPostType } from '../../blogPage.props'
import { SeoModule } from '../../../SeoModule'

export const BlogPost = ({
  setTitle,
  defaultMetaDescription,
}: {
  setTitle: React.Dispatch<React.SetStateAction<string>>
  defaultMetaDescription: string
}) => {
  const router = useRouter()
  const { slug } = router?.query as any
  const { data, isError } = useCmsContent<BlogPostType>({
    key: slug,
  })

  useEffect(() => {
    setTitle(data?.content?.title ?? '')
    
    if (!data && isError) {
      router.push('/404')
    }
  }, [router, data, isError])

  return (
    <BlogPostContent>
      <SeoModule
        title={data?.content.title || ''}
        description={
          data?.content.metaDescription ||
          data?.content.excerpt ||
          defaultMetaDescription
        }
        keywords={data?.content.metaKeywords}
      />
      <CreationDate>{data?.content?.publishDate}</CreationDate>
      <Copy html={data?.content?.content} />
    </BlogPostContent>
  )
}

export const Title = styled(Typography).attrs({
  variant: '4',
  className: 'd-flex justify-content-start mb-5',
})`
  @media (min-width: ${({ theme }) => theme.breakpoints.md.min}) {
    font-size: 3.2rem;
  }
`
const BlogPostContent = styled.div.attrs({
  className: 'd-flex flex-column align-items-start justify-content-center',
})``

const CreationDate = styled(Typography).attrs({
  variant: '8',
  className: 'mb-3',
})``
